import type {FC, PropsWithChildren} from 'react';

import {Paragraph} from '@/modules/foundation/components/typography/paragraph';
import {cn} from '@/modules/foundation/shared/tailwind';

interface Props extends PropsWithChildren {
	classNameOverride?: {
		figure?: string;
		figcaption?: string;
		credit?: string;
		caption?: string;
	};
	credit?: string;
	caption?: string;
}

export const Figure: FC<Props> = ({children, classNameOverride, credit, caption}) => {
	return (
		<>
			{credit || caption ? (
				<figure
					className={cn(['relative', 'h-full', '@container', classNameOverride?.figure])}
				>
					{children}
					<figcaption
						className={cn([
							'flex',
							'flex-col',
							'@lg:flex-row',
							'justify-between',
							'gap-x-8',
							'gap-y-3',
							'mt-4',
							classNameOverride?.figcaption,
						])}
					>
						{caption && (
							<Paragraph asChild size="sm">
								<span
									className={cn(
										[
											'text-grey-15',
											credit && '@lg:w-[80%]',
											'border-l-2',
											'border-grey-border',
											'pl-4',
										],
										classNameOverride?.caption,
									)}
								>
									{caption}
								</span>
							</Paragraph>
						)}
						{credit && (
							<Paragraph asChild size="xs">
								<strong
									className={cn(
										[
											'text-grey-15',
											'font-normal',
											caption && '@lg:w-[20%]',
											'text-left',
											'@lg:text-right',
										],
										classNameOverride?.credit,
									)}
								>
									{credit}
								</strong>
							</Paragraph>
						)}
					</figcaption>
				</figure>
			) : (
				children
			)}
		</>
	);
};
